module.exports = __webpack_public_path__ + "img/icon_tb.df937080.jpg";